import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import {useGeneralInputSpecialCase} from "../../../../hooks/use-general-input.js";
import {alarmArr, alarmSrcArr} from "../utils/alarm-actions-utils.js";
import InputForm from "../../../../components/input/input-form.jsx";
import {MaskDefault} from "../../../../utils/mask.js";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import AccessForm from "../../../../components/reports/access-form/access-form.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
  const handleSpecialInput = useGeneralInputSpecialCase(setFilters);

  return (
    <>
      <div className={`mb-2 ${minMenuHeight}`}>
        <form className={'space-y-4'}>
          <InputDateTime
            id="dtStart"
            label="Data/hora inicial *"
            selected={filters.dtStart}
            onChange={date => handleSpecialInput("dtStart", date)}
          />
          <InputDateTime
            id="dtEnd"
            label="Data/hora final *"
            selected={filters.dtEnd}
            onChange={date => handleSpecialInput("dtEnd", date)}
          />
          <div>
            <SelectComponent
              instanceId="alarmSrc"
              id="alarmSrc"
              label="Origem"
              options={alarmSrcArr}
              value={filters.alarmSrc}
              onChange={selected => handleSpecialInput("alarmSrc", selected)}
              isClearable={false}
            />
          </div>
          <div>
            <SelectComponent
              instanceId="alarm"
              id="alarm"
              label="Assinatura do alarme"
              options={alarmArr}
              value={filters.alarms}
              onChange={selected => handleSpecialInput("alarms", selected)}
              isClearable={false}
            />
          </div>
          <div>
            <InputForm
              id="plate"
              label="Placa"
              mask={MaskDefault.plateNoRestrict}
              value={filters.plate}
              onChange={({target}) => setFilters(prev => ({...prev, plate: target?.value?.toUpperCase()}))}
            />
          </div>
          <div className="ml-1">
            <InputCheckbox
              id="archivedOccurrences"
              label="Contabilizar ocorrências arquivadas"
              checked={filters.archivedOccurrences}
              onChange={() => setFilters(prev => ({...prev, archivedOccurrences: !prev.archivedOccurrences}))}
            />
          </div>
          <div className="ml-1">
            <InputCheckbox
              id="excludeAlarmsAutomaticallySigned"
              label="Excluir alarmes assinados automaticamente"
              checked={filters.excludeAlarmsAutomaticallySigned}
              onChange={() => setFilters(prev => ({...prev, excludeAlarmsAutomaticallySigned: !prev.excludeAlarmsAutomaticallySigned}))}
            />
          </div>
          <AccessForm filters={filters} setFilters={setFilters} isMulti={false} valueAsId={true}/>
        </form>
      </div>
    </>
  );
};

export default Filters;